import { slugify } from '@woolworthsnz/styleguide';

const mealtimeOrder = ['Dinner', 'Dessert', 'Lunch', 'Breakfast', 'Brunch', 'Snacks'];

const mealTimePrioritySortFn = (a: string, b: string): number => {
	const aPos = mealtimeOrder.indexOf(a);
	const bPos = mealtimeOrder.indexOf(b);
	if (aPos === -1) {
		return 1;
	}
	if (bPos === -1) {
		return -1;
	}
	return aPos - bPos;
};

export const mealtimeSlug = (mealtimes: string[]): string => {
	const mealtimesArr = mealtimes.map((t) => t.trim()).sort(mealTimePrioritySortFn);
	return mealtimesArr[0] ? slugify(mealtimesArr[0]) : 'other';
};

export const prioritiseMealTimes = (mealtimes: string[]): string[] => [...mealtimes].sort(mealTimePrioritySortFn);
